import styled from "styled-components";

export const FormTitle = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 18px;
`;

export const Title = styled.h3`
  color: ${(props) => props.theme.colors.text4};
  font-size: 2.2rem;
  font-weight: 800;
`;

export const ExprText = styled.p`
  color: ${(props) => props.theme.colors.text2};
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 160%;

  span {
    display: inline-block;
    margin-top: 4px;
    color: ${(props) => props.theme.colors.errored100};
    font-weight: 700;
  }
`;
